import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  HeartIcon,
  SparklesIcon,
  ChatBubbleLeftRightIcon,
  ShieldCheckIcon,
} from '@heroicons/react/24/solid';
import { useTranslation } from 'react-i18next';
import chatNexusLogo from '../assets/ChatNexus_Logo.png';

const Welcome: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const features = [
    {
      icon: ChatBubbleLeftRightIcon,
      text: t('welcome.features.memory', 'Continuous memory and deep conversation'),
    },
    {
      icon: SparklesIcon,
      text: t('welcome.features.creativity', 'Spark creativity through thoughtful dialogue'),
    },
    {
      icon: HeartIcon,
      text: t('welcome.features.emotional', 'Emotionally intelligent and genuinely caring'),
    },
    {
      icon: ShieldCheckIcon,
      text: t('welcome.features.safe', 'Safe space for authentic expression'),
    },
  ];

  return (
    <div className="min-h-screen bg-dark-bg dark:bg-dark-bg bg-light-bg flex flex-col">
      <div className="mobile-container flex-1 flex flex-col">
        {/* Back button placeholder */}
        <div className="pt-safe" style={{ pointerEvents: 'none' }} />

        {/* Main content */}
        <div className="flex-1 flex flex-col items-center justify-center px-6 pb-8">
          {/* Logo */}
          <img src={chatNexusLogo} alt="Chat Nexus" className="h-14 w-auto mb-8 dark:invert" />

          {/* Subtitle */}
          <p className="text-dark-text-secondary dark:text-dark-text-secondary text-light-text-secondary text-center mb-12">
            {t('welcome.subtitle.part1', 'Your thoughtful partner for')}{' '}
            <span className="text-primary-500">
              {t('welcome.subtitle.part2', 'meaningful conversation')}
            </span>
          </p>

          {/* Features */}
          <div className="space-y-4 mb-12 w-full max-w-sm">
            {features.map((feature, index) => {
              return (
                <div key={index} className="flex items-center space-x-4">
                  <div className="w-2 h-2 bg-primary-500 rounded-full" />
                  <p className="text-dark-text-secondary dark:text-dark-text-secondary text-light-text-secondary text-sm flex-1">
                    {feature.text}
                  </p>
                </div>
              );
            })}
          </div>

          {/* Buttons */}
          <div className="w-full max-w-sm space-y-3">
            <button type="button" onClick={() => navigate('/signup')} className="btn-primary">
              {t('welcome.startJourney', 'Start Your Journey')}
            </button>

            <button type="button" onClick={() => navigate('/login')} className="btn-secondary">
              {t('welcome.welcomeBack', 'Welcome Back')}
            </button>
          </div>

          {/* Terms and Privacy */}
          <p className="text-xs text-dark-text-secondary dark:text-dark-text-secondary text-light-text-secondary text-center mt-8">
            {t('welcome.byContinuing', 'By continuing, you agree to our')}{' '}
            <a href="/terms" className="text-primary-500 underline">
              {t('welcome.termsOfService', 'Terms of Service')}
            </a>{' '}
            {t('welcome.and', 'and')}{' '}
            <a href="/privacy" className="text-primary-500 underline">
              {t('welcome.privacyPolicy', 'Privacy Policy')}
            </a>
          </p>

          {/* Support Contact */}
          <div className="text-sm text-dark-text-secondary dark:text-dark-text-secondary text-light-text-secondary text-center mt-6">
            <p>Support: +1-415-663-6671</p>
            <p className="mt-1">help@chatnexus.com</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Welcome;
